import "./styles.css";
import Background from "./Background";

export default function App() {
  return (
    <div className="App">
      <Background />
    </div>
  );
}
